import React from "react";
import {
    FormControl,
    FormLabel,
    FormErrorMessage,
    Input,
    FormHelperText,
    InputRightElement,
    InputGroup,
    IconButton
  } from '@chakra-ui/react'
import { CustomInputProps } from "../../../types/form";
import { BsFillEyeFill, BsFillEyeSlashFill } from "react-icons/bs";

function FormInput({ label, 
    value, 
    id, 
    type, 
    size,
    errMsg, 
    isRequired,
    isDisabled,
    helperText,
    showPassword,
    togglePassword,
    className,
    onChange,
    labelProps,
    formControlProps,
    ...props
}: CustomInputProps) {
    // function getFieldValidator() {
    //     const result = validateInput(id, value)

    //     if (errMsg) {
    //         setIsError(true);
    //         return <FormErrorMessage>{errMsg}</FormErrorMessage>
    //     }

    //     if (typeof result?.test === 'boolean' && !result?.test) {
    //         setIsError(true)
    //         return <FormErrorMessage>{result?.errMsg}</FormErrorMessage>
    //     }

    //     return null
    // }

    return (
        <FormControl 
            isInvalid={!!errMsg} 
            isRequired={isRequired}
            isDisabled={isDisabled}
            className={className}
            {...formControlProps}
        >
            <FormLabel 
                htmlFor={id} 
                fontSize={'sm' || labelProps?.fontSize} 
                color='rgba(51, 65, 85, 1)' 
                marginBottom={'0.5' || labelProps?.marginBottom}
                {...labelProps}
            >{label}</FormLabel>
                <InputGroup>
                    <Input 
                        id={id} 
                        type={'text' || type} 
                        value={value} 
                        size={'sm' || size}
                        onChange={onChange}
                        borderRadius={'md'}
                        {...props} 
                    />
                    {id === 'password' &&  (
                        <InputRightElement
                            children={
                                <IconButton 
                                    variant="ghost"
                                    aria-label='Toggle password' 
                                    icon={showPassword ? <BsFillEyeFill /> : <BsFillEyeSlashFill /> }
                                    onClick={togglePassword}
                                />
                            }
                        />
                    )}
                </InputGroup>
            {errMsg ? <FormErrorMessage>{errMsg}</FormErrorMessage> : null}         
            { helperText ? <FormHelperText>{helperText}</FormHelperText> : null }
        </FormControl>       
    )
}

export default FormInput